import $ from 'cash-dom';

$(function () {
    const ftcDisclosure = $('#ftc_disclosure.make-sticky');

    if (ftcDisclosure) {
        let bodyTopPadding = ftcDisclosure.height();

        if (bodyTopPadding) {
            $(document.body).css('padding-top', Math.ceil(bodyTopPadding) + 'px');
            ftcDisclosure.removeClass('make-sticky');
            ftcDisclosure.addClass('sticky');
        }
    }
});